import borderRadiuses from "assets/stylesheets/modules/variables/border-radius.module.scss";

export default borderRadiuses;
